/** Sitewide identity and retailer coverage, not this product’s offer count. */
import Link from 'next/link'
import { RETAILER_INTEGRATIONS_DISPLAY } from '@/lib/site-stats'

interface TrustChipsProps {
  /** 'pdp' = full row with borders; 'compact' = lighter inline variant. */
  variant?: 'pdp' | 'compact'
  className?: string
}

export function TrustChips({ variant = 'pdp', className = '' }: TrustChipsProps) {

  const base =
    variant === 'pdp'
      ? 'inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-[11px] font-medium text-gray-600'
      : 'inline-flex items-center gap-1 text-[11px] font-medium text-gray-500'

  return (
    <div
      className={`flex flex-wrap items-center gap-1.5 ${className}`}
      data-testid="trust-chips"
    >
      <Link
        href="/about-us"
        className={`${base} hover:border-[#0469f0]/40 hover:text-[#0469f0] transition-colors`}
        data-testid="trust-chip-identity"
      >
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 2l7 3v6c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V5l7-3z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        </svg>
        Independent
      </Link>
      <span className={base}>We never sell</span>
        <span className={base} data-testid="trust-chip-retailers">
          {RETAILER_INTEGRATIONS_DISPLAY} retailers monitored
        </span>
    </div>
  )
}
